import React, { useState, useEffect } from "react";
import { Select, Spin } from "antd";
import { useTranslation } from "react-i18next";
import Navbar from "../Navbar/Navbar";
import {
    getStoreUsers,
    GetStoreUserMenus,
    UpdateStoreUserMenus,
    getStoreUsersAccessManagement,
} from "../../API  Functions/UserMangement";
import { useSelector } from "react-redux";
import i18next from "i18next";
import AccessRightsTable from "./AccessRightTable";
import { toast } from "react-toastify";
import plus from "../../assets/Images/plus.svg";
import AddUser from "./AddUser";
import LoadingSpinner from "../Loading";
import { getSubstores } from "../../API  Functions/ProfileFunctions";

const { Option } = Select;

const UserAccessManagement = () => {
    const { t } = useTranslation();
    const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
    const login_user_id = useSelector((state) => state?.login?.user?.result?.user_id);

    const [selectedUser, setSelectedUser] = useState("all");
    const [permissions, setPermissions] = useState({});
    const [hasChanges, setHasChanges] = useState(false);
    const [menuData, setMenuData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [usersLoading, setUsersLoading] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState([]);
    const [initialPermissions, setInitialPermissions] = useState({});
    const [showComponent, setShowComponent] = useState(false);
    const [subStores, setSubStores] = useState([]);
  const masterStore = useSelector((state) => state.login.masterStore);
  const userinfo = useSelector((state) => state?.login?.user?.result);

  const [fromStore, setFromStore] = useState(masterStore || null);
console.log('fromStore===>',fromStore);

  useEffect(() => {
    if (masterStore) {
      getSubStoresData();
    }
  }, [masterStore]);


  const getSubStoresData = () => {
      getSubstores(masterStore?.store_id).then((res) => {
        console.log("Substores Res", res);
  
        setSubStores(res?.response);
      });
    };
    
    // Fetch Users for dropdown
    const fetchUsers = async (id) => {
        try {
            setLoading(true);
            const payload = { store_id: id || company_id };
            const res = await getStoreUsersAccessManagement(payload);

            if (res?.result?.[0]?.response) {
                const filteredUsers = res.result[0].response.filter(
                    (user) => 
                    // (user.user_type === "online_sale" || user.user_type === "wh_manager") &&
                     user.active
                );
                setUsers(filteredUsers);

                // if (filteredUsers.length === 0) {
                //     toast.info(t("No users found. Please add users to manage access rights."));
                // }
            }
        } catch (err) {
            console.error("Error fetching users:", err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch Menus (all users or specific user)
    const fetchMenus = async (user) => {
        try {
            setLoading(true);
            const lang = i18next.language === "ar" ? "ar_001" : "en_US";

            let payload = {
                store_id: company_id,
                user_id: false,
                lang,
                is_all_user: true,
            };

            if (user !== "all") {
                payload = {
                    store_id: company_id,
                    user_id: user,
                    lang,
                    is_all_user: false,
                };
            }

            const res = await GetStoreUserMenus(payload);

            if (res?.result?.response) {
                const menus = res.result.response;
                setMenuData(menus);

                const mappedPermissions = {};
                // menus.forEach((menu) => {
                //     mappedPermissions[`menu_${menu.parent_menu_id}`] = {
                //         read: menu.can_read || false,
                //         edit: menu.can_write || false,
                //     };
                //     menu.sub_menu_list?.forEach((submenu) => {
                //         mappedPermissions[`submenu_${submenu.sub_menu_id}`] = {
                //             read: submenu.can_read || false,
                //             edit: submenu.can_write || false,
                //         };
                //     });
                // });


                // for e ordeer 
                menus.forEach((menu) => {
                    const isEOrders = menu.name === "E-Orders";

                    mappedPermissions[`menu_${menu.parent_menu_id}`] = {
                        read: isEOrders ? true : menu.can_read || false,
                        edit: menu.can_write || false,
                    };

                    menu.sub_menu_list?.forEach((submenu) => {
                        const isViewOrders = submenu.name === "View Orders";
                        mappedPermissions[`submenu_${submenu.sub_menu_id}`] = {
                            read: isViewOrders ? true : submenu.can_read || false,
                            edit: submenu.can_write || false,
                        };
                    });
                });

                setPermissions(mappedPermissions);
                setInitialPermissions(JSON.parse(JSON.stringify(mappedPermissions)));
            }
        } catch (err) {
            console.error("Error fetching menus:", err);
        } finally {
            setLoading(false);
        }
    };
console.log("users===>",users);

    useEffect(() => {
        fetchUsers(fromStore?.store_id);
        fetchMenus("all");
    }, [fromStore]);

    const arePermissionsEqual = (perm1, perm2) => {
        const keys1 = Object.keys(perm1);
        const keys2 = Object.keys(perm2);
        if (keys1.length !== keys2.length) return false;

        for (let key of keys1) {
            if (!perm2[key]) return false;
            if (perm1[key].read !== perm2[key].read) return false;
            if (perm1[key].edit !== perm2[key].edit) return false;
        }
        return true;
    };

    // const handlePermissionChange = (key, type, value, submenus = []) => {
    //     setPermissions((prev) => {
    //         const updated = { ...prev };

    //         if (key.startsWith("menu_")) {
    //             if (!updated[key]) updated[key] = { read: false, edit: false };
    //             updated[key][type] = value;
    //             if (type === "edit" && value) updated[key].read = true;

    //             submenus?.forEach((submenu) => {
    //                 const subKey = `submenu_${submenu.sub_menu_id}`;
    //                 if (!updated[subKey]) updated[subKey] = { read: false, edit: false };

    //                 if (type === "read") updated[subKey].read = value;
    //                 if (type === "edit") {
    //                     updated[subKey].edit = value;
    //                     if (value) updated[subKey].read = true;
    //                 }
    //             });
    //         }

    //         if (key.startsWith("submenu_")) {
    //             if (!updated[key]) updated[key] = { read: false, edit: false };
    //             updated[key][type] = value;
    //             if (type === "edit" && value) updated[key].read = true;

    //             const parentMenu = menuData.find((menu) =>
    //                 menu.sub_menu_list?.some((sm) => `submenu_${sm.sub_menu_id}` === key)
    //             );
    //             if (parentMenu) {
    //                 const parentKey = `menu_${parentMenu.parent_menu_id}`;
    //                 if (!updated[parentKey]) updated[parentKey] = { read: false, edit: false };

    //                 updated[parentKey].read = parentMenu.sub_menu_list.some(
    //                     (sm) => updated[`submenu_${sm.sub_menu_id}`]?.read
    //                 );

    //                 updated[parentKey].edit = parentMenu.sub_menu_list.some(
    //                     (sm) => updated[`submenu_${sm.sub_menu_id}`]?.edit
    //                 );

    //                 if (updated[parentKey].edit) updated[parentKey].read = true;
    //             }
    //         }

    //         setHasChanges(!arePermissionsEqual(updated, initialPermissions));
    //         return updated;
    //     });
    // };



    const handlePermissionChange = (key, type, value, submenus = []) => {
        // Detect if it's a menu or submenu
        const isMenu = key.startsWith("menu_");
        const isSubmenu = key.startsWith("submenu_");

        let itemName = "";
        if (isMenu) {
            const menuId = parseInt(key.replace("menu_", ""));
            const menu = menuData.find((m) => m.parent_menu_id === menuId);
            itemName = menu?.name;
        } else if (isSubmenu) {
            const submenuId = parseInt(key.replace("submenu_", ""));
            const submenu = menuData
                .flatMap((m) => m.sub_menu_list || [])
                .find((sm) => sm.sub_menu_id === submenuId);
            itemName = submenu?.name;
        }

        //  Prevent turning off view access for E-Orders and View Orders
        if ((itemName === "E-Orders" || itemName === "View Orders") && type === "read" && value === false) {
            return;
        }

        setPermissions((prev) => {
            const updated = { ...prev };

            if (isMenu) {
                if (!updated[key]) updated[key] = { read: false, edit: false };
                updated[key][type] = value;
                if (type === "edit" && value) updated[key].read = true;

                submenus?.forEach((submenu) => {
                    const subKey = `submenu_${submenu.sub_menu_id}`;
                    if (!updated[subKey]) updated[subKey] = { read: false, edit: false };

                    if (type === "read") updated[subKey].read = value;
                    if (type === "edit") {
                        updated[subKey].edit = value;
                        if (value) updated[subKey].read = true;
                    }
                });
            }

            if (isSubmenu) {
                if (!updated[key]) updated[key] = { read: false, edit: false };
                updated[key][type] = value;
                if (type === "edit" && value) updated[key].read = true;

                // Update parent based on its submenus
                const parentMenu = menuData.find((menu) =>
                    menu.sub_menu_list?.some((sm) => `submenu_${sm.sub_menu_id}` === key)
                );
                if (parentMenu) {
                    const parentKey = `menu_${parentMenu.parent_menu_id}`;
                    if (!updated[parentKey]) updated[parentKey] = { read: false, edit: false };

                    updated[parentKey].read = parentMenu.sub_menu_list.some(
                        (sm) => updated[`submenu_${sm.sub_menu_id}`]?.read
                    );

                    updated[parentKey].edit = parentMenu.sub_menu_list.some(
                        (sm) => updated[`submenu_${sm.sub_menu_id}`]?.edit
                    );

                    if (updated[parentKey].edit) updated[parentKey].read = true;
                }
            }

            setHasChanges(!arePermissionsEqual(updated, initialPermissions));
            return updated;
        });
    };


    const toggleMenu = (menuId) => {
        setExpandedMenus((prev) =>
            prev.includes(menuId)
                ? prev.filter((id) => id !== menuId)
                : [...prev, menuId]
        );
    };

    const handleUserChange = (value) => {
        setSelectedUser(value);
        fetchMenus(value);
    };

    const handleSave = async () => {
        setLoading(true);

        // const menuList = menuData.map((menu) => ({
        //     parent_menu_id: menu.parent_menu_id,
        //     can_read: permissions[`menu_${menu.parent_menu_id}`]?.read || false,
        //     can_create: false,
        //     can_write: permissions[`menu_${menu.parent_menu_id}`]?.edit || false,
        //     can_delete: false,
        //     sub_menu_list:
        //         menu.sub_menu_list?.map((submenu) => ({
        //             sub_menu_id: submenu.sub_menu_id,
        //             can_read: permissions[`submenu_${submenu.sub_menu_id}`]?.read || false,
        //             can_create: false,
        //             can_write: permissions[`submenu_${submenu.sub_menu_id}`]?.edit || false,
        //             can_delete: false,
        //         })) || [],
        // }));

        // for eorder 
        const menuList = menuData.map((menu) => {
            const isEOrders = menu.name === "E-Orders";

            return {
                parent_menu_id: menu.parent_menu_id,
                can_read: isEOrders ? true : permissions[`menu_${menu.parent_menu_id}`]?.read || false,
                can_create: false,
                can_write: permissions[`menu_${menu.parent_menu_id}`]?.edit || false,
                can_delete: false,
                sub_menu_list:
                    menu.sub_menu_list?.map((submenu) => {
                        const isViewOrders = submenu.name === "View Orders";

                        return {
                            sub_menu_id: submenu.sub_menu_id,
                            can_read: isViewOrders ? true : permissions[`submenu_${submenu.sub_menu_id}`]?.read || false,
                            can_create: false,
                            can_write: permissions[`submenu_${submenu.sub_menu_id}`]?.edit || false,
                            can_delete: false,
                        };
                    }) || [],
            };
        });

        const payload = {
            store_id: company_id,
            user_id: selectedUser === "all" ? false : selectedUser,
            is_all_user: selectedUser === "all",
            menu_list: menuList,
        };

        const res = await UpdateStoreUserMenus(payload);

        if (res?.result?.status_code === 200) {
            toast.success(t("Permissions updated successfully"));
            setInitialPermissions(JSON.parse(JSON.stringify(permissions)));
            // setSelectedUser("all");
            // fetchMenus("all");
            fetchMenus(selectedUser);
            setHasChanges(false);
        } else {
            toast.error(t("Failed to update permissions."));
            console.error("Failed to update permissions:", res.error);
        }

        setLoading(false);
    };

    return (
        <>
            {loading && <LoadingSpinner />}
            <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
                <Navbar heading={t("User Access Management")} />
                {showComponent ? (
                    <div className="ms-3 me-3 ">
                        <AddUser
                            onClose={() => {
                                setShowComponent(false);
                                fetchUsers();
                            }}
                        />
                    </div>
                ) : (
                    <div className="ms-3 font-extrabold overflow-y-auto custom-scrollbar">
                        <div className="flex flex-row items-end justify-between mb-10 mt-5">
                            <div className="flex w-6/12">
                            {(userinfo?.is_master_store || userinfo?.master_store_id) && (<>
                             <div className="flex flex-col w-1/2 me-2">
                                <label className="text-gray-600 text-sm font-medium">
                                    {t("Select Store")}
                                </label>
                         <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select From Store")}
                  className="h-10 "
                  value={fromStore?.store_id || null}
                  // disabled={productList.length > 0}
                  onChange={(value) => {
                    setSelectedUser('all');
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);
                    setFromStore(selected);
                  }}
                  showSearch
                >
                  {/* Master Store option */}
                  {/* {(masterStore?.store_id !== selectedSubStore?.store_id) && ( */}
                    <Select.Option
                      key={masterStore?.store_id}
                      value={masterStore?.store_id}
                    >
                      {i18next.language === "ar"
                        ? masterStore?.store_name_ar
                        : masterStore?.store_name}
                    </Select.Option>
                  {/* )} */}

                  {/* Sub Stores */}
                  {subStores.map((store) => (
                      <Select.Option
                        key={store.store_id}
                        value={store.store_id}
                      >
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
                </div></>)}
                                
                            <div className="flex flex-col w-1/2">
                                <label className="text-gray-600 text-sm font-medium">
                                    {t("Select User")}
                                </label>
                                <Select
                                    placeholder={t("Choose a user")}
                                    value={selectedUser}
                                    onChange={handleUserChange}
                                    disabled={subStores?.length > 0 && !fromStore?.store_id}
                                    className="w-full"
                                    loading={usersLoading}
                                    notFoundContent={
                                        usersLoading ? <Spin size="small" /> : t("No Users Found")
                                    }
                                >
                                    <Option key="all" value="all">
                                        {t("All Users")}
                                    </Option>
                                    {users.map((user) => (
                                        <Option key={user.user_id} value={user.user_id}>
                                            {user.name} (
                                            {user.phone && user.phone.trim() !== ""
                                                ? user.phone
                                                : user.email}
                                            )
                                        </Option>
                                    ))}
                                </Select>
                            </div>
</div>
                            <div className="flex gap-5 me-4">
                                <button
                                    className="w-36 h-10 bg-white text-primaryBlue font-semibold rounded-lg border border-primaryBlue disabled:opacity-50"
                                    onClick={() => {
                                        if (selectedUser === "all") {
                                            const emptyPermissions = {};
                                            menuData.forEach((menu) => {
                                                emptyPermissions[`menu_${menu.parent_menu_id}`] = { read: false, edit: false };
                                                menu.sub_menu_list?.forEach((submenu) => {
                                                    emptyPermissions[`submenu_${submenu.sub_menu_id}`] = { read: false, edit: false };
                                                });
                                            });
                                            setPermissions(emptyPermissions);
                                        } else {
                                            setPermissions(initialPermissions);
                                        }
                                        setHasChanges(false);
                                    }}
                                    disabled={users.length === 0}
                                >
                                    {t("cancel")}
                                </button>

                                <button
                                    type="submit"
                                    className={`w-36 h-10 rounded-lg font-semibold ${hasChanges && users.length > 0
                                        ? "bg-primaryBlue text-white"
                                        : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
                                        }`}
                                    disabled={!hasChanges || users.length === 0}
                                    onClick={handleSave}
                                >
                                    {t("save")}
                                </button>
                            </div>
                        </div>

                        {/* Permission Table or Fallback Message */}
                        {users.length === 0 ? (
                            <div className="flex flex-col items-center justify-center text-center py-10 text-gray-800 text-base font-medium">
                                {t("No users found. Please add users to manage access rights.")}
                                <button
                                    onClick={() => setShowComponent(true)}
                                    // onClick={() => {
                                    //     if (checkPermission("/settings/usermanagement", isGinne)) {
                                    //         setShowComponent(true);
                                    //     }
                                    // }}
                                    className={`font-semibold w-40 mt-5  h-10 border  rounded-lg bg-primaryBlue text-white text-base   flex justify-center items-center gap-2`}
                                    type="submit"
                                >
                                    <img src={plus} alt="plus" />
                                    <p className="">{t("Add User")}</p>
                                </button>
                            </div>

                        ) : (
                            <div className="bg-white rounded-lg text-sm">
                                <AccessRightsTable
                                    menuData={menuData}
                                    permissions={permissions}
                                    expandedMenus={expandedMenus}
                                    toggleMenu={toggleMenu}
                                    handlePermissionChange={handlePermissionChange}
                                    loading={loading}
                                    selectedUser={selectedUser}
                                    showRights={["read", "edit"]}
                                    disabled={users.length === 0} // <<< NEW PROP
                                />
                            </div>
                        )}
                    </div>
                )}
                {/* {showComponent && (
                <AddUser
                    onClose={() => {
                        setShowComponent(false);
                        // setstoreuser(null);
                        fetchUsers(); // Re-fetch after adding user
                    }}
                // isEdit={storeuser}
                />
            )} */}
            </div>
        </>

    );
};

export default UserAccessManagement;
